/**
 * Client-side activity logger.
 * Inserts into activity_logs table via the authenticated Supabase client.
 */

import { supabase } from "@/integrations/supabase/client";

interface LogActivityParams {
  event_type: string;
  actor_id?: string | null;
  actor_email?: string | null;
  entity_type: string;
  entity_id: string;
  metadata?: Record<string, any>;
}

export async function logActivity(params: LogActivityParams) {
  const id = `actlog_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  try {
    await supabase.from("activity_logs").insert({
      id,
      event_type: params.event_type,
      actor_id: params.actor_id || null,
      actor_email: params.actor_email || null,
      entity_type: params.entity_type,
      entity_id: params.entity_id,
      metadata: params.metadata || {},
    });
  } catch (err) {
    console.warn("[activityLogger] Failed to log activity:", err);
  }
}
